import type { SelectOption } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportFormat, ExportOption } from './consts'
import { useMemo } from 'react'

export function useExportOptions(
  allowDownload?: boolean
): SelectOption<ExportOption>[] {
  const translations = useTranslate({
    download: 'common.download',
    email: 'common.email',
    save: 'common.save-in-user-exports',
  })

  const downloadOption = useMemo(
    () =>
      allowDownload
        ? {
            value: ExportOption.DOWNLOAD,
            label: translations.download,
          }
        : null,
    [allowDownload, translations.download]
  )

  const options = useMemo<SelectOption<ExportOption>[]>(
    () => [
      {
        value: ExportOption.MAIL,
        label: translations.email,
      },
      {
        value: ExportOption.SAVE,
        label: translations.save,
      },
    ],
    [translations.email, translations.save]
  )

  if (downloadOption) return [...options, downloadOption]

  return options
}

export function useExportFormatOptions(
  excludedFormatOptions?: ExportFormat[]
): SelectOption<ExportFormat>[] {
  const translations = useTranslate({
    excel: 'common.excel',
    excelFlat: 'common.excel-flat',
    pdf: 'common.pdf',
    csv: 'common.csv',
    visma: 'common.visma-payroll',
    vismaNew: 'common.visma-new',
    poweroffice: 'common.poweroffice',
    twentyfourSevenOffice: 'common.twentyfour-seven-office',
    tripletex: 'common.tripletex',
  })

  const formatOptions = [
    {
      value: ExportFormat.PDF,
      label: translations.pdf,
    },
    {
      value: ExportFormat.EXCEL,
      label: translations.excel,
    },
    {
      value: ExportFormat.EXCEL_FLAT,
      label: translations.excelFlat,
    },
    {
      value: ExportFormat.VISMA,
      label: translations.visma,
    },
    {
      value: ExportFormat.VISMA_NEW,
      label: translations.vismaNew,
    },
    {
      value: ExportFormat.POWEROFFICE,
      label: translations.poweroffice,
    },
    {
      value: ExportFormat.TWENTYFOUR_SEVEN_OFFICE,
      label: translations.twentyfourSevenOffice,
    },
    {
      value: ExportFormat.TRIPLETEX,
      label: translations.tripletex,
    },
  ]

  if (excludedFormatOptions) {
    const newFormatOptions = formatOptions.filter(
      value => !excludedFormatOptions.includes(value.value)
    )
    return newFormatOptions
  }
  return formatOptions
}
